import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    list: {
        listStyleType: "disc",
        paddingLeft: theme.spacing(3),
        paddingBlock: theme.spacing(2),
        marginTop: "0 !important",
    },
    listItem: {
        display: "list-item",
        padding: theme.spacing(0),
        color: theme.palette.secondary.main,
        "& > .MuiListItemText-root > .MuiTypography-root": {
            fontWeight: theme.typography.fontWeightLight,
        },
    },
    installationDate: {
        padding: theme.spacing(1, 1.5),
        backgroundColor: theme.palette.background.main,
        marginBottom: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        width: "fit-content",
    },
}));
